import { Component, OnInit, HostListener } from '@angular/core';
import { ApplicationMenuService } from './application-menu.service';
import { LayoutService } from "../../layout.service";
import { Router, NavigationEnd } from "@angular/router";
import { CommonService } from "@app/shared/common/common.service";
import { I18nService } from '@app/shared/i18n';
// import { log } from 'console';
import { environment } from '@env/environment';

declare var $: any;
interface menuItem {
  img: string,
  title: string,
  src: string,
  hiddenClass: string,
  active: string
}

@Component({
  selector: 'sa-application-menu',
  templateUrl: './application-menu.component.html'
})

export class ApplicationComponent implements OnInit {
  hiddenList: menuItem[];
  menuList: menuItem[];
  shownList: menuItem[];
  isLoading: boolean;
  location: string;
  appData: any;
  appCode: string;
  appId: number;
  appPath: string;
  isApplicationsLoading: boolean;
  maximumIconWidth: number = 158;
  reloadHead: boolean = true;
  languageChanged = false;
  language: string = "";
  applicationMenuClicked: boolean = false;
  selectedMenu;
  tempProductCode = '';
  constructor(private applicationMenuService: ApplicationMenuService, private router: Router,
    private layoutService: LayoutService, private commonService: CommonService, private i18n: I18nService) {
    this.menuList = [];
    this.hiddenList = [];
    this.shownList = [];
    this.appData = {};
    this.appCode = "";
    this.i18n.getEmittedLanguageValue().subscribe(item => {
      this.languageChanged = true;
      this.language = item.key;
      this.defaultHeadMenu();
      this.reloadHead = false;
      setTimeout(() => {
        this.languageChanged = false;
        this.reloadHead = true;
      }, 800);
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.location = this.router.url;
        this.sendAppCodeUsingUrl(this.location, this.appData);
      }
    });
    let appDataSubscription = this.layoutService.subscribeAppDataChange((data:any) => {
      let appCode = data.code;
      this.appCode = appCode;
      this.appId = data.id;
      this.appPath = data.path;
    });
  }
  defaultHeadMenu() {
    this.isLoading = true;
    this.menuList = [];
    this.hiddenList = [];
    this.shownList = [];
    this.appData = {};
    this.appCode = "";
    this.isApplicationsLoading = true;
    let data = new FormData();
    if (!this.language) {
      this.language = this.i18n.currentLanguage.key;
    }
    data.append('instanceId', localStorage.getEncryptedItem('instanceId'));
    data.append('companyUserId', localStorage.getEncryptedItem('companyUserId'));
    data.append('language', this.language);
    data.append('module', 'ngtMPur');
    data.append('userId', localStorage.getEncryptedItem('loginId'));
    data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    data.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    let object = this.commonService.createObject(data)
    let token = this.commonService.createToken(object)
    let encryptedToken = this.commonService.encrypt(token)
    let encrData = new FormData()
    encrData.append("encrToken", encryptedToken);
    this.applicationMenuService.getTopNavList(encrData).subscribe((data:any) => {
      if (!data.status && data.isUnauthenticated) {
        this.commonService.logout();        
        return false;
      }
      localStorage.setEncryptedItem("lastRequestTime", data.RESPONSETIME);
      this.manipulateAppData(data.DATA);
      this.createMenuItem(this.appData);
      this.isLoading = false;
      this.initMenuItems();
      let codes = [];
      for (let i = 0; i < data.DATA.length; i++) {
        if(data.DATA[i].PRODUCTCODE != '')
        codes.push(data.DATA[i].PRODUCTCODE)
      }
      localStorage.setEncryptedItem("productCodes", codes);
      if (this.router.url.indexOf("/settings/") == -1) {
        this.sendAppCodeUsingUrl(this.router.url, this.appData);
      }
    });
  }
  ngOnInit() {

  }
  manipulateTopNavList(data) {
    let arrTree = [];
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        let node = data[i];
        if (typeof node === 'object') {
          arrTree.push(node);

        }
      }
    }
  }

  manipulateAppData(data) {
    if (data && data.length) {
      this.appData = {};
      for (let i = 0; i < data.length; i++) {
        let app = data[i];
        this.appData[app.LABEL] = {};
        this.appData[app.LABEL].icon = app.ICON;
        this.appData[app.LABEL].id = app.ID;
        this.appData[app.LABEL].label = app.LABEL;
        this.appData[app.LABEL].module = app.MODULE;
        this.appData[app.LABEL].code = app.SYSTEM;
        this.appData[app.LABEL].productCode = app.PRODUCTCODE;
      }
    }
  }

  sendAppCodeUsingUrl(location, appData) {   
    let appCode = "dash";
    if (location.indexOf("/settings/") !== -1) {
      appCode = "settings";
      this.appCode = appCode;
      this.layoutService.triggerAppDataChange({ "code": appCode, showDefault: false });
      localStorage.setItem('lastVisitedModule',this.appCode);
    } else if (location && !$.isEmptyObject(appData)) {
      let locationArray = location.split('/')

      for (let i in appData) {
        if (appData[i].code == locationArray[1]) {
          this.appCode = appData[i].code;
          this.appId = appData[i].id;
          this.appPath = appData[i].module;
          break;
        }
      }      
      this.layoutService.triggerAppDataChange({ "code": this.appCode, showDefault: false, "id": this.appId, "path": this.appPath });
      localStorage.setItem("appDetail", JSON.stringify({ "code": this.appCode, showDefault: false, "id": this.appId, "path": this.appPath }));
      if(!this.applicationMenuClicked){
        if( localStorage.getItem('lastVisitedModule') != this.appCode  && this.appCode != ""){
          if( this.appCode != 'invoice'){
            for (let key in this.appData) {
              if( this.appData[key].code === this.appCode){
                this.selectedMenu = this.appData[key].productCode;
                this.tempProductCode = this.appData[key].productCode;
                break;
              }
            }
            let formDataSession = new FormData()
            formDataSession.append("instanceId", localStorage.getEncryptedItem('instanceId'));
            formDataSession.append('companyId', localStorage.getEncryptedItem('companyId'));
            formDataSession.append('instanceUserId', localStorage.getEncryptedItem('loginId'));
            formDataSession.append('productCode', this.selectedMenu);
            formDataSession.append('userId', localStorage.getEncryptedItem('loginId'));
            formDataSession.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
            formDataSession.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
            let object = this.commonService.createObject(formDataSession)
            let token = this.commonService.createToken(object)
            let encryptedToken = this.commonService.encrypt(token)
            let encrData = new FormData()
            encrData.append("encrToken", encryptedToken);
            this.applicationMenuService.insertSession(encrData)
            .subscribe((data:any) => {
              if(!data.status && data.isUnauthenticated) {
                this.commonService.logout();
                
                return false;
              }
              localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);            
            });    
          }
        }      
      }
      localStorage.setItem('lastVisitedModule',this.appCode);
    }
    this.applicationMenuClicked = false;
  }

  createMenuItem(data) {
    this.menuList = [];
    for (let i in data) {
      this.menuList.push(data[i]);
    }
  }


  ngAfterViewInit() {
  }

  initMenuItems() {
    //This is workaround related to issue : expressionchangedafterithasbeencheckederror in angular 4.2.x
    setTimeout(() => {
      this.addItemInDropDown();
      this.isApplicationsLoading = false;
    }, 1000);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.addItemInDropDown();
  }

  addItemInDropDown() {
    this.hiddenList = [];
    this.shownList = [];
    let maxIcons = this.maximumIconsInParent();
    this.shownList = this.menuList.slice(0, maxIcons);
    this.hiddenList = this.menuList.slice(maxIcons, this.menuList.length);
  }

  maximumIconsInParent() {
    let width = $("body").width();
    let maxIcons = 1;
    if (width >= 992) {
      let logoWidth = $("#logo-container").width();
      let optionWidth = $("#header-options").width();
      let headerWidth = $("#header").width();
      let remainingWidth = headerWidth - (logoWidth + optionWidth);
      if (remainingWidth > this.maximumIconWidth) {
        maxIcons = Math.floor(remainingWidth / this.maximumIconWidth) + 1;
      }
    }
    if (width <= 991) {
      let logoWidth = $("#logo-container").width();
      let optionWidth = $("#header-options").width();
      let headerWidth = $("#header").width();
      let remainingWidth = headerWidth - (logoWidth + optionWidth);
      if (remainingWidth > this.maximumIconWidth) {
        maxIcons = Math.floor(remainingWidth / this.maximumIconWidth);
      }
    }
    return maxIcons;
  }

  onClickApplicationItem(item) {
    this.applicationMenuClicked = true;
    if(this.tempProductCode != item.productCode && item.productCode != ''){
      this.tempProductCode = item.productCode;
      let formDataSession = new FormData()
      formDataSession.append("instanceId", localStorage.getEncryptedItem('instanceId'));
      formDataSession.append('companyId', localStorage.getEncryptedItem('companyId'));
      formDataSession.append('instanceUserId', localStorage.getEncryptedItem('loginId'));
      formDataSession.append('productCode', item.productCode);    
      formDataSession.append('userId', localStorage.getEncryptedItem('loginId'));
      formDataSession.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
      formDataSession.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
      let object = this.commonService.createObject(formDataSession)
      let token = this.commonService.createToken(object)
      let encryptedToken = this.commonService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this.applicationMenuService.insertSession(encrData)
      .subscribe((data:any) => {
        if(!data.status && data.isUnauthenticated) {
          this.commonService.logout();
          
          return false;
        }
        localStorage.setEncryptedItem("lastRequestTime",data.RESPONSETIME);
      
      });
    }
      let modules=this.commonService.modules;
      // let rights = this.commonService.getCookie(environment.userRights) ? 
			// 	JSON.parse(this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.userRights)))).userRights :
			// 	this.commonService.logout();
      let rights = localStorage.getEncryptedItem('userRights') || this.commonService.logout();

      let rightsArray = [];
      if(rights)
        rightsArray = rights ? rights.split(',') : [];
      for(let i=0;i<modules.length;i++){
        // if(modules[i].module==item.code&&rightsArray.includes(modules[i].right)){
        if(modules[i].module==item.code){
          this.layoutService.triggerAppDataChange({ "code": item.code, showDefault: true, "id": item.id, "path": item.module });
          this.appCode = item.code;
          localStorage.setItem("appDetail", JSON.stringify({ "code": item.code, showDefault: true, "id": item.id, "path": item.module }));
          this.layoutService.setNavId(item.id,item.module);

        }
      }
  }
}
